/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useContext } from 'react';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports

// local imports
import OrganisationDashboardImg from '../../assets/organisationDashboard.svg';

const UserNotApproved = props => {

    // contexts
    const { colors, fontFamily, fontWeight } = useContext(ThemeContext);

    return (
        <div>
            <div className='mt-5 ml-3 py-2 text-center' style={{ backgroundColor: "#FFC107" }}>
                <p className='m-0' style={{ fontFamily: fontFamily.primary, fontWeight: fontWeight.medium, color: colors.white }}>
                    <i className="fas fa-exclamation-circle"></i> Account not yet approved
                </p>
            </div>

            <div className='row my-5'>
                <div className='col-md-6 col-12 text-center'>
                    <img id="user-not-approved-img" src={OrganisationDashboardImg} alt="img" style={{ maxHeight: "350px" }} />
                </div>

                <div className='col-md-6 col-12 py-auto'>
                    <h2 id="not-approved-main-heading" style={{ fontFamily: fontFamily.primary, fontSize: "2rem", fontWeight: fontWeight.regular }}>
                        We have received your request to sign up as a Counsellor
                    </h2>
                    <h3 id="not-approved-sub-heading" className='mt-3' style={{ fontFamily: fontFamily.primary, fontSize: "1.3rem", fontWeight: fontWeight.regular }}>Please wait for an Approval of your account from our side</h3>

                    <br />
                    <br />

                    <p id="not-approved-para" style={{ fontFamily: fontFamily.primary }}>Note - It may take upto 2 business days to approve</p>
                </div>
            </div>
        </div>
    )
}

export default UserNotApproved;